import moment from "moment";
import { reaction } from "mobx";
export var isTechnicianAvailable = function (scheduleTimeBlocks) {
    return scheduleTimeBlocks.some(function (schedule) {
        return schedule.technicianId &&
            schedule.technicianId !== '0' &&
            schedule.maxSum > 0;
    });
};
var sortSchedules = function (x, y) { return x.maxSum === y.maxSum ?
    moment(x.schedulestarttime).diff(moment(y.schedulestarttime))
    : y.maxSum - x.maxSum; };
export var caculateRecommendSchedulesForUrgent = function (schedules) {
    if (!isTechnicianAvailable(schedules))
        return [];
    // pick two days (six records) and sort by maxSum desc, 
    // schedulestarttime esc and filter maxSum is 0
    // Due to the filter maxSum is 0 , we have to resort the list 
    var recommends = schedules.slice(0, 6)
        .sort(sortSchedules)
        .filter(function (schedule) { return schedule.maxSum > 0; })
        .sort(sortSchedules);
    recommends = recommends.length > 3 ? recommends.slice(0, 3) : recommends;
    var remainCount = 3 - recommends.length;
    if (remainCount === 0)
        return recommends;
    // if remainCount records < 3, then need to supply from the last 24 records
    var supplyRecommends = schedules.slice(6, 30)
        .sort(sortSchedules)
        .filter(function (schedule) { return schedule.maxSum > 0; });
    return recommends.concat(remainCount > supplyRecommends.length ?
        supplyRecommends : supplyRecommends.slice(0, remainCount));
};
export var caculateRecommendSchedules = function (schedules) {
    if (!isTechnicianAvailable(schedules))
        return [];
    return schedules.slice(0, 30).sort(sortSchedules)
        .filter(function (schedule) { return schedule.maxSum > 0; })
        .slice(0, 3);
};
export function generatorReactionHandler(expression, effect) {
    var handler = {
        dispose: null,
        start: function () {
            if (handler.dispose)
                return;
            handler.dispose = reaction(expression, effect);
        },
        stop: function () {
            if (handler.dispose) {
                handler.dispose();
                handler.dispose = null;
            }
        },
        executeWithoutEffect: function (callback) {
            handler.stop();
            callback();
            handler.start();
        }
    };
    handler.start();
    return handler;
}
